<script setup>
import { ref, defineProps } from 'vue'

const props = defineProps({
  isFullPage: { type: Boolean, default: false },
  delay: { type: Boolean, default: false }
})

// delay :
// Prevents the spinner from flashing briefly in the viewport if
// loading time is virtually null.
const show = ref(!props.delay)
setTimeout(() => {
  show.value = true
}, 100)
</script>
<template>
  <div :class="['loading-overlay', { 'is-active': show }, { 'is-full-page': isFullPage }]">
    <div class="loading-background" />
    <div class="loading-icon" />
  </div>
</template>
<style scoped lang="sass">
$loading-background: #ffffff80 !default
$loading-icon-color: #dbdbdb !default
$loading-icon-size: 3em !default
$loading-full-page-icon-size: 5em !default

@mixin overlay($offset: 0)
  bottom: $offset
  left: $offset
  position: absolute
  right: $offset
  top: $offset

.loading-overlay
  align-items: center
  display: none
  justify-content: center
  overflow: hidden
  z-index: 29
  @include overlay
  &.is-active
    display: flex
  &.is-full-page
    position: fixed
    z-index: 999
    .loading-icon
      &:after
        top: calc(50% - #{$loading-full-page-icon-size * 0.5})
        left: calc(50% - #{$loading-full-page-icon-size * 0.5})
        width: $loading-full-page-icon-size
        height: $loading-full-page-icon-size

  .loading-background
    background: $loading-background
    @include overlay

  .loading-icon
    @include overlay
    &:after
      animation: spinAround .5s infinite linear
      border: 2px solid $loading-icon-color
      border-radius: 9999px
      border-right-color: transparent
      border-top-color: transparent
      content: ""
      display: block
      position: absolute
      top: calc(50% - #{$loading-icon-size * 0.5})
      left: calc(50% - #{$loading-icon-size * 0.5})
      width: $loading-icon-size
      height: $loading-icon-size
      border-width: 0.25em
</style>
